import {
  LISTA_TIPOS_TURMA,
  LISTA_TIPOS_TURMA_SUCESSO,
  SALVA_TIPO_TURMA,
  ATUALIZA_TIPO_TURMA,
  REMOVE_TIPO_TURMA,
  SHOW_MESSAGE,
  ON_SHOW_SUCCESS_MESSAGE
} from 'constants/ActionTypes';

export const listaTiposTurma = (search) => ({
  type: LISTA_TIPOS_TURMA,
  payload: { search: search == undefined ? '' : search }
});

export const listaTiposTurmaSucesso = (tipos) => ({
  type: LISTA_TIPOS_TURMA_SUCESSO,
  payload: { tipos }
});

export const salvaTipoTurma = (tipo) => ({
  type: SALVA_TIPO_TURMA,
  payload: tipo
});

export const atualizaTipoTurma = (id, tipo) => ({
  type: ATUALIZA_TIPO_TURMA,
  payload: { id, tipo }
});

export const removeTipoTurma = (id) => ({
  type: REMOVE_TIPO_TURMA,
  payload: id
});

export const showAuthMessage = (message) => ({
  type: SHOW_MESSAGE,
  payload: message
});

export const showSuccessMessage = (message) => ({
  type: ON_SHOW_SUCCESS_MESSAGE,
  payload: message
});

